<template>
  <div>
    <b-row align-h="center" style="margin-bottom: 40px; text-align: center">
      <b-col cols="12" md="4" v-if="buyFor==='self'">
        <font-awesome-icon :icon="['fas', 'check-circle']" class="text-success my-auto success-icon"></font-awesome-icon>
        <h3 class="font-weight-bolder mt-3">Payment Successful!</h3>
        <p class="" style="margin-bottom: 55px">{{msgCredit}}</p>
        <p>Your credits now is </p>
        <h1 class="mb-4 font-weight-bolder credit-text">{{lastCredit}}</h1>
        <a class="btn btn-primary btn-block" :href="getFromApps?'musicverse://transaction_done':'/#/home'" >Continue</a>
      </b-col>
      <b-col cols="12" md="5" v-if="buyFor==='other'">
        <font-awesome-icon :icon="['fas', 'check-circle']" class="text-success my-auto success-icon" ></font-awesome-icon>
        <h3 class="font-weight-bolder mt-3">Thank you for purchasing!</h3>
        <p class="" style="margin-bottom: 29px">{{msgCredit}}</p>
        <p class="mb-1">Here’s  your redemption code</p>
        <div class="position-relative">
          <h1 class="mb-4 font-weight-bolder credit-text" >{{redemptionCode}}</h1>
          <a class="d-flex position-absolute cursor-pointer copy-icon-link" @click="copyRedemptionCode">
            <VueCustomTooltip label="Copied to Clipboard" :position="isMobile?'is-left':'is-top'" :sticky="true" :active="tooltipActive">
              <img src="@/assets/copy-icon.png" class="copy-icon"/>
              <input type="hidden" id="redemption-code" :value="redemptionCode">
            </VueCustomTooltip>
          </a>
        </div>
        <p style="margin-bottom: 21px">Redeem this code at the app</p>
        <p style="margin-bottom: 13px">Or</p>
        <p style="margin-bottom: 23px">Share it via</p>
        <div class="social-item d-flex justify-content-between px-5" style="margin-bottom: 28px">
          <a :href="`mailto:?subject=${encodeURI('MusicVerse Redemption Code')}&body=${getMessageShare}`" :target="isMobile?'_self':'_blank'" class="d-flex">
            <img src="@/assets/mail-icon.png"  />
          </a>
<!--          <a class="d-flex" :href="`https://m.me/`" :target="isMobile?'_self':'_blank'">-->
<!--            <img src="@/assets/messenger-icon.png" />-->
<!--          </a>-->
          <a class="d-flex" :href="getFromApps?buildUrlShareExternal(`https://api.whatsapp.com/send?text=${getMessageShare}`):`https://api.whatsapp.com/send?phone=&text=${encodeURI(getMessageShare)}`" :target="isMobile?'_self':'_blank'">
            <img src="@/assets/wa-icon.png"  />
          </a>
          <a class="d-flex" :href="getFromApps?buildUrlShareExternal(`https://line.me/R/msg/text/?${getMessageShare}`):`https://line.me/R/msg/text/?${encodeURI(getMessageShare)}`" :target="isMobile?'_self':'_blank'">
            <img src="@/assets/line-icon.png" />
          </a>
        </div>
        <a class="btn btn-primary btn-block" :href="getFromApps?'musicverse://transaction_done':'/#/home'" >Continue</a>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import VueCustomTooltip from '@adamdehaven/vue-custom-tooltip'
import { mapActions, mapGetters } from 'vuex';
const MobileDetect = require('mobile-detect');
const md = new MobileDetect(window.navigator.userAgent);

export default {
  name: "SuccessPage",
  data() {
    return {
      buyFor : '',
      msgCredit:'',
      lastCredit:0,
      redemptionCode:'',
      tooltipActive:false,
      isMobile: !!md.phone()
    }
  },
  async mounted(){
    if(this.creditTrxData!==''){
      if(this.$route.query.type!==undefined){
        let resp = {data:{
            message:'',
          }};
        if(this.$route.query.type==='self'){
          resp.data['credit_balance'] = this.getUser.data.credit_balance+this.creditTrxData.price_credit;
          resp.data.message = this.creditTrxData.price_credit+' Credits have been added to your account'
        }else{
          resp.data['redemption_code'] = this.creditTrxData.payment!==undefined?this.creditTrxData.payment.redemption_code:'';
        }
        if(this.creditTrxData.session_id!==undefined){
          resp = await this.requestConfirmPayment({
            session_id:this.creditTrxData.session_id
          })
        }
        if(!!resp){
          window.fbq('track', 'Purchase', {
            value: this.creditTrxData.price_dollar,
            currency: this.creditTrxData.currency,
            test_event_code:'TEST31016'
          })
          this.removePaymentData();
          await this.requestDetailUser();
          this.msgCredit = resp.data.message;
          if(resp.data.credit_balance!==undefined){
            this.buyFor = 'self'
            this.lastCredit = resp.data.credit_balance;
          }else{
            this.buyFor = 'other'
            this.redemptionCode = resp.data.redemption_code;
          }
        }else{
          this.setPaymentError({
            msg:this.getMessage,
            type:'webtopup',
          })
          this.$router.push({name:'TransactionFailedPage'});
        }
      }else{
        this.$router.push({ name: 'HomePage' });
      }
    }else{
      this.$router.push({ name: 'HomePage' });
    }

  },
  computed:{
    ...mapGetters('PaymentModule', ['creditTrxData']),
    ...mapGetters('NotificationModule', ['getLoading', 'getStatus', 'getMessage', 'getErrorCode']),
    ...mapGetters('AuthModule', ['getUser','getFromApps']),
    getMessageShare(){
      return 'Here\'s your redemption code: '+this.redemptionCode;
    }
  },
  methods:{
    ...mapActions('PaymentModule', ['requestConfirmPayment','removePaymentData','setPaymentError']),
    ...mapActions('AuthModule', ['requestDetailUser']),
    back(){
      if(this.showPrice){
        this.showPrice = false;
      }else{
        this.$router.push({ name: 'HomePage' });
      }
    },
    goToHome(){
      this.$router.push({ name: 'HomePage' });
    },
    copyRedemptionCode () {
      let testingCodeToCopy = document.querySelector('#redemption-code')
      testingCodeToCopy.setAttribute('type', 'text')
      testingCodeToCopy.select()

      try {
        const successful = document.execCommand('copy');
        if(successful){
          this.tooltipActive = true;
          setTimeout(()=>{
            this.tooltipActive = false;
          },1000)
        }
      } catch (err) {
        console.log('Oops, unable to copy');
      }
      testingCodeToCopy.setAttribute('type', 'hidden')
      window.getSelection().removeAllRanges()
    },
    buildUrlShareExternal(url){
      return `musicVerse://external_url?url=${encodeURI(url)}`;
    }
  },
  components: {
    VueCustomTooltip
  },
}
</script>

<style scoped>
  .cursor-pointer{
    cursor: pointer;
  }
  .success-icon{
    font-size: 134px
  }
  .credit-text{
    font-size: 100px;
  }
  .copy-icon-link{
    right: -40px;top: 25px;
  }
  .copy-icon{
    width: 40px; height: 50px; margin:auto
  }
  .social-item img{
    width: 45px;
    height: 45px;
  }
  @media screen and (max-width: 767.98px) {
    .credit-text{
      font-size: 50px;
    }
    .copy-icon-link{
      right: 0;
      top: 12px;
    }
    .copy-icon{
      width: 20px; height: 30px; margin:auto
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Success.vue